/**
 * Round a numeric value to 2 decimal places
 * @param value - The value to round
 * @returns The value rounded to 2 decimal places
 */
export function roundToTwoDecimals(value: number): number {
  return Number(value.toFixed(2));
}

function calculatePercent(flat: number, base: number): number {
  return base > 0 ? roundToTwoDecimals((flat / base) * 100) : 0;
}

function calculateFlat(base: number, percent: number): number {
  return roundToTwoDecimals((base * percent) / 100);
}

/**
 * Calculate finance commission percentage from flat amount
 * @param fundedAmount - The funded amount
 * @param financeCommissionFlat - The commission flat amount
 * @returns The calculated commission percentage rounded to 2 decimal places
 */
export function calculateCommissionPercent(fundedAmount: number, financeCommissionFlat: number): number {
  return calculatePercent(financeCommissionFlat, fundedAmount);
}

/**
 * Calculate finance commission flat amount from percentage
 * @param fundedAmount - The funded amount
 * @param financeCommissionPercent - The commission percentage
 * @returns The calculated commission flat amount rounded to 2 decimal places
 */
export function calculateCommissionFlat(fundedAmount: number, financeCommissionPercent: number): number {
  return calculateFlat(fundedAmount, financeCommissionPercent);
}

/**
 * Calculate markup percentage from flat amount and cost
 * @param markupFlat - The markup flat amount
 * @param cost - The dealer/product cost
 * @returns The calculated markup percentage rounded to 2 decimal places
 */
export function calculateMarkupPercent(markupFlat: number, cost: number): number {
  return calculatePercent(markupFlat, cost);
}

/**
 * Calculate markup flat amount from percentage and cost
 * @param cost - The dealer/product cost
 * @param markupPercent - The markup percentage
 * @returns The calculated markup flat amount rounded to 2 decimal places
 */
export function calculateMarkupFlat(cost: number, markupPercent: number): number {
  return calculateFlat(cost, markupPercent);
}
